import getMuiTheme from 'material-ui/styles/getMuiTheme';
import {
  black, // "#000000"
  darkBlack, // rgba(0, 0, 0, 0.87)
  fullBlack, // rgba(0, 0, 0, 1)
  grey400, // "#bdbdbd"
  grey800, // "#424242"
  grey900, // "#212121"
  white, // "#ffffff"
} from 'material-ui/styles/colors';

const theme = getMuiTheme({
  fontFamily: 'Montserrat',
  palette: {
    // navbar, cancel link, checkboxes in drawer
    primary1Color: grey900,
    // calendar selection circle
    primary2Color: grey800,
    primary3Color: black,
    accent1Color: grey400,
    accent2Color: white,
    // calendar hover circle
    accent3Color: grey400,
    borderColor: grey400,
    canvasColor: white,
    // datepicker header color
    pickerHeaderColor: grey900,
    // body text and side arrows
    textColor: darkBlack,
    // hamburger menu, calendar heading text, selected day colour (click and select)
    alternateTextColor: white,
    // calendar shadow color
    shadowColor: fullBlack,
  },
  stepper: {
    iconColor: '#33691E',
    inactiveIconColor: grey400,
  },
});

export default theme;



// WEBPACK FOOTER //
// ./src/theme.js